import { render, staticRenderFns } from "./TeamInvitationForm.vue?vue&type=template&id=4839968e&scoped=true"
import script from "./TeamInvitationForm.vue?vue&type=script&lang=js"
export * from "./TeamInvitationForm.vue?vue&type=script&lang=js"
import style0 from "./TeamInvitationForm.vue?vue&type=style&index=0&id=4839968e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4839968e",
  null
  
)

export default component.exports